/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { PartnerEmbedAdminDetails } from "../models/partner-embed-admin-details";
@Injectable({
  providedIn: "root",
})
class PartnerEmbedService extends __BaseService {
  static readonly partnerEmbedGetPartnerEmbedsPath =
    "/api/admin/partner/PartnerEmbed/GetPartnerEmbeds";
  static readonly partnerEmbedCreatePartnerEmbedPath =
    "/api/admin/partner/PartnerEmbed/CreatePartnerEmbed";
  static readonly partnerEmbedUpdatePartnerEmbedPath =
    "/api/admin/partner/PartnerEmbed/UpdatePartnerEmbed";
  static readonly partnerEmbedDeletePartnerEmbedPath =
    "/api/admin/partner/PartnerEmbed/DeletePartnerEmbed";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  partnerEmbedGetPartnerEmbedsResponse(): __Observable<
    __StrictHttpResponse<Array<PartnerEmbedAdminDetails>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/partner/PartnerEmbed/GetPartnerEmbeds`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PartnerEmbedAdminDetails>>;
      })
    );
  }
  partnerEmbedGetPartnerEmbeds(): __Observable<
    Array<PartnerEmbedAdminDetails>
  > {
    return this.partnerEmbedGetPartnerEmbedsResponse().pipe(
      __map((_r) => _r.body as Array<PartnerEmbedAdminDetails>)
    );
  }

  /**
   * @param partnerEmbedDetails undefined
   */
  partnerEmbedCreatePartnerEmbedResponse(
    partnerEmbedDetails: PartnerEmbedAdminDetails
  ): __Observable<__StrictHttpResponse<PartnerEmbedAdminDetails>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = partnerEmbedDetails;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/admin/partner/PartnerEmbed/CreatePartnerEmbed`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PartnerEmbedAdminDetails>;
      })
    );
  }
  /**
   * @param partnerEmbedDetails undefined
   */
  partnerEmbedCreatePartnerEmbed(
    partnerEmbedDetails: PartnerEmbedAdminDetails
  ): __Observable<PartnerEmbedAdminDetails> {
    return this.partnerEmbedCreatePartnerEmbedResponse(
      partnerEmbedDetails
    ).pipe(__map((_r) => _r.body as PartnerEmbedAdminDetails));
  }

  /**
   * @param partnerEmbedDetails undefined
   */
  partnerEmbedUpdatePartnerEmbedResponse(
    partnerEmbedDetails: PartnerEmbedAdminDetails
  ): __Observable<__StrictHttpResponse<PartnerEmbedAdminDetails>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = partnerEmbedDetails;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/admin/partner/PartnerEmbed/UpdatePartnerEmbed`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PartnerEmbedAdminDetails>;
      })
    );
  }
  /**
   * @param partnerEmbedDetails undefined
   */
  partnerEmbedUpdatePartnerEmbed(
    partnerEmbedDetails: PartnerEmbedAdminDetails
  ): __Observable<PartnerEmbedAdminDetails> {
    return this.partnerEmbedUpdatePartnerEmbedResponse(
      partnerEmbedDetails
    ).pipe(__map((_r) => _r.body as PartnerEmbedAdminDetails));
  }

  /**
   * @param partnerEmbedId undefined
   */
  partnerEmbedDeletePartnerEmbedResponse(
    partnerEmbedId?: number
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (partnerEmbedId != null)
      __params = __params.set("partnerEmbedId", partnerEmbedId.toString());
    let req = new HttpRequest<any>(
      "DELETE",
      this.rootUrl + `/api/admin/partner/PartnerEmbed/DeletePartnerEmbed`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param partnerEmbedId undefined
   */
  partnerEmbedDeletePartnerEmbed(
    partnerEmbedId?: number
  ): __Observable<boolean> {
    return this.partnerEmbedDeletePartnerEmbedResponse(partnerEmbedId).pipe(
      __map((_r) => _r.body as boolean)
    );
  }
}

module PartnerEmbedService {}

export { PartnerEmbedService };
